import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function StepTwo({data, incrementStep, decrementStep, handleClose}) {
  const validationSchema = Yup.object().shape({
    allergies: Yup.boolean(),
    allergiesText: Yup.string()
    .when('allergies', {
      is: true,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().notRequired()
    }),
    special: Yup.boolean(),
    specialText: Yup.string()
    .when('special', {
      is: true,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().notRequired()
    }),
    inhaler: Yup.boolean(),
    inhalerText: Yup.string()
    .when('inhaler', {
      is: true,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().notRequired()
    }),
    dislikes: Yup.boolean(),
    dislikesText: Yup.string()
    .when('dislikes', {
      is: true,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().notRequired()
    }),
    favourites: Yup.boolean(),
    favouritesText: Yup.string().required('Required')
  });

  return (
    <div className='child-reg-step'>
      <Formik
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={(values) => {incrementStep(values); handleClose();}}
        >
        {({
          values,
          setFieldValue,
          handleChange,
          handleSubmit
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className='form-body p-3 custom-scrollbar'>
            <Form.Group className='mb-3'>
                <Form.Label>What are your child's favourite Sports / Games / Activities?</Form.Label>
                <Form.Control
                    as='textarea'
                    name='favouritesText'
                    rows={3}
                    placeholder='Please Describe'
                    className='mt-2'
                    value={values.favouritesText}
                    onChange={handleChange}
                  />
                <ErrorMessage name='favouritesText' component='p' className='error-message' />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>Is there anything your child don't like (food, games etc) or is scared of?</Form.Label>
                <div className='d-flex'>
                  <Form.Check
                    type='radio'
                    name='dislikes'
                    id='dislikes-yes'
                    label='Yes'
                    className='me-3'
                    onChange={(e) => {
                      e.target.checked && 
                      setFieldValue('dislikes', true);
                    }}
                    defaultChecked={values.dislikes}
                  />
                  <Form.Check
                    type='radio'
                    name='dislikes'
                    id='dislikes-no'
                    label='No'
                    onChange={(e) => {
                      e.target.checked && 
                      setFieldValue('dislikes', false);
                    }}
                    defaultChecked={!values.dislikes}
                  />
                </div>
                {
                  values.dislikes &&
                  <Form.Control
                    as='textarea'
                    name='dislikesText'
                    rows={3}
                    placeholder='Please Describe'
                    className='mt-2'
                    value={values.dislikesText}
                    onChange={handleChange}
                  />
                }
                <ErrorMessage name='dislikesText' component='p' className='error-message' />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>Does your child/children have any allergies, chronic illness, or medical conditions? If yes, please describe.</Form.Label>
                <div className='d-flex'>
                  <Form.Check
                    type='radio'
                    name='allergies'
                    id='allergies-yes'
                    label='Yes'
                    className='me-3'
                    onChange={(e) => {
                      e.target.checked && 
                      setFieldValue('allergies', true);
                    }}
                    defaultChecked={values.allergies}
                  />
                  <Form.Check
                    type='radio'
                    name='allergies'
                    id='allergies-no'
                    label='No'
                    onChange={(e) => {
                      e.target.checked && 
                      setFieldValue('allergies', false);
                    }}
                    defaultChecked={!values.allergies}
                  />
                </div>
                {
                  values.allergies &&
                  <Form.Control
                    as='textarea'
                    name='allergiesText'
                    rows={3}
                    placeholder='Please Describe'
                    className='mt-2'
                    value={values.allergiesText}
                    onChange={handleChange}
                  />
                }
                <ErrorMessage name='allergiesText' component='p' className='error-message' />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>Is the Child prescribed any medication / inhaler? If yes, please explain any instructions.</Form.Label>
                <div className='d-flex'>
                  <Form.Check
                    type='radio'
                    name='inhaler'
                    id='inhaler-yes'
                    label='Yes'
                    className='me-3'
                    onChange={(e) => {
                      e.target.checked && 
                      setFieldValue('inhaler', true);
                    }}
                    defaultChecked={values.inhaler}
                  />
                  <Form.Check
                    type='radio'
                    name='inhaler'
                    id='inhaler-no'
                    label='No'
                    onChange={(e) => {
                      e.target.checked && 
                      setFieldValue('inhaler', false);
                    }}
                    defaultChecked={!values.inhaler}
                  />
                </div>
                {
                  values.inhaler &&
                  <Form.Control
                    as='textarea'
                    name='inhalerText'
                    rows={3}
                    placeholder='Please Describe'
                    className='mt-2'
                    value={values.inhalerText}
                    onChange={handleChange}
                  />
                }
                <ErrorMessage name='inhalerText' component='p' className='error-message' />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>Does your Child have Special Education Needs & Disability (SEND)? If yes, please specify.</Form.Label>
                <div className='d-flex'>
                  <Form.Check
                    type='radio'
                    name='special'
                    id='special-yes'
                    label='Yes'
                    className='me-3'
                    onChange={(e) => {
                      e.target.checked && 
                      setFieldValue('special', true);
                    }}
                    defaultChecked={values.special}
                  />
                  <Form.Check
                    type='radio'
                    name='special'
                    id='special-no'
                    label='No'
                    onChange={(e) => {
                      e.target.checked && 
                      setFieldValue('special', false);
                    }}
                    defaultChecked={!values.special}
                  />
                </div>
                {
                  values.special &&
                  <Form.Control
                    as='textarea'
                    name='specialText'
                    rows={3}
                    placeholder='Please Describe'
                    className='mt-2'
                    value={values.specialText}
                    onChange={handleChange}
                  />
                }
                <ErrorMessage name='specialText' component='p' className='error-message' />
              </Form.Group>
            </div>
            <div className='form-foot p-3 d-flex justify-content-end'>
              <Button variant='secondary' type='button' size='sm' className='me-2' onClick={handleClose}>
                Cancel
              </Button>
              <Button variant='primary' type='button' size='sm' className='me-2' onClick={() => decrementStep(values)}>
                Back
              </Button>
              <Button variant='primary' type='submit' size='sm'>
                Save & Register
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}
